import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
import { FilterArgs, StateFilterVariables } from './queryVariables/filters';
export class CategoryResource extends EntityResource {
    constructor() {
        super({
            entityName: 'category',
            listName: 'categories'
        });
        this.getFields = {
            id: true,
            name: true,
            state: true
        };
        this.listFields = {
            id: true,
            name: true,
            state: true
        };
        this.addVariables = { category: 'CategoryInput!' };
        this.addArgs = { category: new VariableType('category') };
        this.updateVariables = { id: 'Int!', category: 'CategoryInput!' };
        this.updateArgs = {
            id: new VariableType('id'),
            category: new VariableType('category')
        };
        this.listVariables = StateFilterVariables;
        this.listArgs = FilterArgs;
    }
}
export const categoryResource = new CategoryResource();
//# sourceMappingURL=category.resource.js.map